import { callUIAPI } from "../utils/apiUtils";
import { METHOD_GET } from "../utils/apiUtilsConstants";

export const profilePicCache = {
  s3Key: null,
  resolvedUrl: null,
};


export const getProfilePicUploadURL = async (userId, contentType) => {
  return callUIAPI(`users/${userId}/profile-pic-upload-url`, { contentType }, METHOD_GET, true)
    .then(response => response.data);
};

export const getProfilePicDownloadURL = async (key) => {
  return callUIAPI(`users/presigned-url`, { key }, METHOD_GET, true)
    .then(response => response.data.url);
};

export const getAuthorBio = async (userId) => {
  return callUIAPI(`users/${userId}/authorbio`, null, METHOD_GET, true)
    .then((response) => {
      return response.data.authorBio;
    });
};